import React, { memo } from 'react'
import { Typography } from '@mui/material'

export interface AlertItemProps {
    title: string,
    value: any
}

function OrderBookItem({ title, value }: AlertItemProps) {
    return (
        <div style={{ display: 'flex', justifyContent: 'space-between', flexDirection: 'row' }}>
            <Typography style={{ fontSize: '13px', padding: '2px' }}
                        sx={{ color: (theme) => theme.palette.text.disabled }}>{title}</Typography>
            <Typography className="font-feature-num"
                        style={{ fontSize: '13px', lineHeight: 1.5, padding: '2px' }}>{value}</Typography>
        </div>
    )
}

export default memo(OrderBookItem)